import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchTrialHierarchy = async (trialId) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/photos/trial-hierarchy/${trialId}/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useTrialHierarchy = ({ trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["trial_hierarchy", trialId],
    queryFn: () => fetchTrialHierarchy(trialId),
    enabled: enabled && Boolean(trialId),
    refetchOnWindowFocus: false,
  });
};

export default useTrialHierarchy;
